(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getDrawerSectionId() {
    const drawer = getDrawer();
    if (!drawer) return null;
    const id = drawer.dataset.sectionId;
    return id && id !== 'cart-drawer' ? id : 'cart-drawer';
  }

  function getSectionsToRequest() {
    const sections = [];
    const drawer = getDrawer();
    if (drawer) sections.push(getDrawerSectionId());
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
    return sections;
  }

  function setLoading(btn, on) {
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.setAttribute('aria-busy', 'false');
      btn.removeAttribute('disabled');
    }
  }

  async function onSubmit(form, btn) {
    const variantInput = form.querySelector('[data-tz-offer-variant]');
    const errorEl = form.parentElement.querySelector('[data-tz-offer-error]');
    if (!variantInput || !variantInput.value) return;

    if (errorEl) {
      errorEl.setAttribute('hidden', '');
      errorEl.textContent = '';
    }
    setLoading(btn, true);

    const drawer = getDrawer();
    const sections = getSectionsToRequest();

    const body = {
      items: [
        {
          id: Number(variantInput.value),
          quantity: Number(form.querySelector('[name="quantity"]').value || 1),
        },
      ],
    };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart.');
      }

      if (window.publish && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'tz-available-offers',
          productVariantId: variantInput.value,
          cartData: data,
        });
      }

      if (drawer && data.sections) {
        drawer.renderContents(data);
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        // No drawer on this template (e.g. cart page) — refresh to reflect cart.
        window.location = window.routes.cart_url;
      }
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        errorEl.removeAttribute('hidden');
      }
    } finally {
      setLoading(btn, false);
    }
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-tz-offer-form] form').forEach((form) => {
      if (form.dataset.tzBound) return;
      form.dataset.tzBound = '1';
      const btn = form.querySelector('button[name="add"]');
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        onSubmit(form, btn);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => bind(document));
  document.addEventListener('shopify:section:load', (e) => bind(e.target));
})();